import getServiceCatalog from '@rover/react-lib/src/pages/shared/serviceCatalog/getServiceCatalog';
import type {
  CatalogEntry,
  CatalogIcon,
  GetServiceCatalogOptions,
} from '@rover/react-lib/src/pages/shared/serviceCatalog/types';
import type { BrandCountryServices } from '@rover/shared/js/hooks/useLocalizedBrandCountryServicesByServiceType';

export interface OverviewService {
  id: string;
  name: string;
  location: string | null;
  for: string;
  description: string;
  cta: string;
  imageUrl: string;
  href: string;
  icon: CatalogIcon;
}

export interface OverviewTab {
  id: string;
  label: string;
  services: OverviewService[];
}

const toOverviewService = (entry: CatalogEntry): OverviewService => ({
  id: entry.serviceSlug,
  name: entry.name,
  location: entry.location,
  for: entry.for,
  description: entry.description,
  cta: entry.cta,
  imageUrl: entry.imageUrl,
  href: entry.href ?? '',
  icon: entry.icon,
});

const getServiceOverviewCategories = (
  servicesByType: BrandCountryServices | null,
  options: GetServiceCatalogOptions = {}
): OverviewTab[] =>
  getServiceCatalog(servicesByType, options).map((tab) => ({
    id: tab.id,
    label: tab.label,
    services: tab.entries.map(toOverviewService),
  }));

export default getServiceOverviewCategories;
